<h4 class="sidebar-title">{{ 'DATA_MODEL_CUSTOMIZATION.CATEGORIES.TITLE' | translate }}</h4>
<ul class="item-list">
  <li 
    *ngFor="let item of items; let i = index"
    [class.active]="item === selectedItem"
    (click)="selectItem(item, i)"
    >
    {{ item | translate}}
  </li>
</ul>
